import { Skeleton } from '@mui/material';
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useTranslation } from 'react-i18next';

const getLocalizedTrustpilotWidgetData = (locale: string) => {
  switch (locale) {
    case 'de':
      return {
        locale: 'de-DE',
        token: 'c7763353-a332-48ae-9138-0250bb1a4336',
      };
    default:
      return {
        locale: 'en-US',
        token: '1d783247-779e-4932-bbb9-ef47d2406acd',
      };
  }
};

const DELAY_FOR_TP_LOADING_MS = 1500;

const TrustpilotWidget: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { i18n } = useTranslation();
  const data = useMemo(() => getLocalizedTrustpilotWidgetData(i18n.language), [i18n.language]);
  const tpEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, DELAY_FOR_TP_LOADING_MS);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      {isLoading && <Skeleton variant="rectangular" height={52} width="100%" />}
      <div
        style={{ display: isLoading ? 'none' : 'block' }}
        ref={(ref) => {
          if (ref) {
            tpEl.current = ref;
            (window as any).Trustpilot.loadFromElement(ref, true);
          }
        }}
        className="trustpilot-widget"
        data-locale={data.locale}
        data-token={data.token}
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id="67ec068ce3692dd8cf659835"
        data-style-height="52px"
        data-style-width="100%"
      >
        <a
          style={{ display: isLoading ? 'none' : 'block' }}
          href="https://www.trustpilot.com/evaluate/klang.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          TrustPilot
        </a>
      </div>
    </>
  );
};

export default TrustpilotWidget;
